import { z } from "zod";
import { auditActorFields } from "../common/audit.js";
import { pagedResponse, paginationQuerySchema } from "../common/pagination.js";
import { booleanQueryParam } from "../common/query-params.js";
export const storeInfo = z.object({
    id: z.string().uuid(),
    code: z.string(),
    name: z.string(),
    storeType: z.string().nullable(),
    region: z.string().nullable(),
    city: z.string().nullable(),
    stateRegion: z.string().nullable(),
    postalCode: z.string().nullable(),
    countryCode: z.string().regex(/^[A-Z]{2}$/).nullable(),
    timezone: z.string(),
    latitude: z.number().nullable(),
    longitude: z.number().nullable(),
    isActive: z.boolean(),
    metadata: z.record(z.unknown()),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
    ...auditActorFields,
});
export const createStoreRequest = z.object({
    code: z.string().min(1).max(100),
    name: z.string().min(1).max(255),
    storeType: z.string().max(64).nullish(),
    region: z.string().max(128).nullish(),
    city: z.string().max(128).nullish(),
    stateRegion: z.string().max(128).nullish(),
    postalCode: z.string().max(32).nullish(),
    countryCode: z.string().regex(/^[A-Z]{2}$/).nullish(),
    timezone: z.string().max(64).default("UTC"),
    latitude: z.number().min(-90).max(90).nullish(),
    longitude: z.number().min(-180).max(180).nullish(),
    isActive: z.boolean().default(true),
    metadata: z.record(z.unknown()).default({}),
});
export const updateStoreRequest = createStoreRequest.partial().refine((v) => Object.keys(v).length > 0, { message: "At least one field required" });
export const listStoresQuery = paginationQuerySchema.extend({
    isActive: booleanQueryParam.optional(),
    search: z.string().max(255).optional(),
});
export const storesListResponse = pagedResponse(storeInfo);
// store-category linking
export const storeCategoryLink = z.object({
    id: z.string().uuid(), // store_categories.public_id
    categoryId: z.string().uuid(), // categories.public_id
    categoryCode: z.string(),
    categoryName: z.string(),
    isActive: z.boolean(),
    sortOrder: z.number().int().nullable(),
});
export const storeCategoriesListResponse = z.object({ items: z.array(storeCategoryLink) });
export const listStoreCategoriesQuery = z.object({
    // When true, only links with is_active = true are returned (used by New Scan).
    activeOnly: booleanQueryParam.optional(),
});
export const linkStoreCategoryRequest = z.object({
    categoryId: z.string().uuid(),
    isActive: z.boolean().default(true),
    sortOrder: z.number().int().nullish(),
});
export const updateStoreCategoryRequest = z.object({
    isActive: z.boolean().optional(),
    sortOrder: z.number().int().nullable().optional(),
}).refine((v) => Object.keys(v).length > 0, { message: "At least one field required" });
// Flip every category on/off for a store in one call. `isActive: true` links
// (or reactivates) every globally-active category; `false` deactivates every
// existing link. `affected` is the number of rows inserted or updated.
export const bulkSetStoreCategoriesRequest = z.object({
    isActive: z.boolean(),
});
export const bulkSetStoreCategoriesResponse = z.object({
    affected: z.number().int(),
});
//# sourceMappingURL=stores.schemas.js.map